module.exports = __webpack_public_path__ + "img/followbtn.ad824cc8.svg";